import { createContext } from "react";
import { makeAutoObservable, observable  } from "mobx";
import { PemissionService } from "../services/permissionService";
import { getCurrentUser } from "../../../../Utility/modules/helpers";
class PermissionStore {
  constructor() {
    makeAutoObservable(this);
  }

  priviledges = observable.map({});

  userPriviledges = observable.map({});
  userPermissions = observable.map({});
  isLoadingPrivilege = false;
  isAddingUsertoRole = false;
  permissions = observable.map({});
  isLoadingPermissions = false;
  usersInRole = observable.map({});
  showAddUserToRoleDialog = false;
  isLoadingUsersInRole = false;
  selectedRole = {};
  isLoadinggrouppermissions = false;
  isSettingUserPermission = false;
  isloadingUserRoles = false;
  isloadingUserPermissions = false;

  async loadPriviledgesFromDB() {
    try {
      this.isLoadingPrivilege = true;
      const res = await PemissionService.getinitialData();

      this.priviledges.clear();

      res.priviledges.forEach((priviledge) => {
        this.priviledges.set(priviledge.groupId, priviledge);
      });
      this.isLoadingPrivilege = false;
    } catch (error) {
      throw error;
    } finally {
      this.isLoadingPrivilege = false;
    }
  }
  async createOrUpdatePriviledge(priviledge, action) {
    try {
      const res = await PemissionService.createOrUpdatePriviledge(
        priviledge,
        action
      );
      let newRoleId;

      this.priviledges.set(res.priviledge.groupId, res.priviledge);
      newRoleId = res.priviledge.groupId;

      return newRoleId;
    } catch (error) {
      throw error;
    }
  }

  async removePriviledge(priviledge) {
    const res = await PemissionService.removePriviledge(priviledge);

    console.log(res);
    this.priviledges.delete(res.groupId);
  }

  async addUserstoRole(users, groupId) {
    this.isAddingUsertoRole = true;
    const addedUsers = await PemissionService.addUserstoRole(users, groupId);

    addedUsers.forEach((user) => {
      this.usersInRole.set(user.id, {
        ...user,
        fullName: `${user.firstName} ${user.lastName}`,
      });
    });
    this.isAddingUsertoRole = false;
  }

  async getGroupPermissions(groupId) {
    try {
      this.isLoadinggrouppermissions = true;
      this.isLoadingUsersInRole = true;
      const res = await PemissionService.getGroupPermissions(groupId);
      this.permissions.clear();
      this.usersInRole.clear();
      if (res && res.permissions.length) {
        res.permissions.forEach((p) => {
          this.permissions.set(p.menuId, p);
        });
      }

      if (res.users.length) {
        res.users.forEach((u) => {
          this.usersInRole.set(u.id, u);
        });
      }
      this.isLoadinggrouppermissions = false;
      this.isLoadingUsersInRole = false;
    } catch (error) {
      throw error;
    } finally {
      this.isLoadinggrouppermissions = false;
      this.isLoadingUsersInRole = false;
    }
  }

  async updatePermission(permission) {
    try {
      const res = await PemissionService.updatePermission(permission);
      return res;
    } catch (error) {
      throw error;
    }
  }

  async removeUserFromRole(userId, roleId) {
    try {
      await PemissionService.removeUserFromRole(userId, roleId);

      this.usersInRole.delete(userId);
    } catch (error) {
      throw error;
    }
  }

  async getUserRoles() {
    try {
      this.isloadingUserRoles = true;
      const currentUser = getCurrentUser();
      const { id } = currentUser;

      const res = await PemissionService.getUserRoles(id);

      this.userPriviledges.clear();
      if (res.length) {
        res.forEach((g) => {
          this.userPriviledges.set(g.groupId, g);
        });
      }

      return res;
    } catch (error) {
      throw error;
    }
  }

  async getUserPermissions() {
    try {
      this.isloadingUserPermissions = true;
      const currentUser = getCurrentUser();
      const { id } = currentUser;
      const res = await PemissionService.getUserPermissions(id);
      console.log(res);
      this.userPermissions.clear();
      if (res.length) {
        res.forEach((p) => {
          this.userPermissions.set(p.subMenuId, p);
        });
      }

      window.localStorage.setItem("permissions", JSON.stringify(res));
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async setUserPermisions(permissions) {
    try {
      this.isSettingUserPermission = true;
      await PemissionService.setUserPermisions(permissions);
    } catch (error) {
      throw error;
    }
  }
}


export default createContext(new PermissionStore());

